import { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { formatApiError } from "../lib/api";
import { toast } from "sonner";
import Spinner from "../components/Spinner";

const GoogleBtn = () => {
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  const goGoogle = () => {
    const redirectUrl = window.location.origin + "/auth/callback";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };
  return (
    <button onClick={goGoogle} type="button" className="w-full border rounded-md py-2.5 flex items-center justify-center gap-2 hover:bg-gray-50 transition" data-testid="google-login-btn">
      <svg width="18" height="18" viewBox="0 0 48 48"><path fill="#FFC107" d="M43.6 20.5H42V20H24v8h11.3C33.7 32.5 29.3 36 24 36c-6.6 0-12-5.4-12-12s5.4-12 12-12c3 0 5.7 1.1 7.8 3l5.7-5.7C33.6 6 29 4 24 4 12.9 4 4 12.9 4 24s8.9 20 20 20 20-8.9 20-20c0-1.2-.1-2.4-.4-3.5z"/><path fill="#FF3D00" d="M6.3 14.7l6.6 4.8C14.8 16 19 12 24 12c3 0 5.7 1.1 7.8 3l5.7-5.7C33.6 6 29 4 24 4 16.3 4 9.6 8.4 6.3 14.7z"/><path fill="#4CAF50" d="M24 44c5 0 9.5-1.9 12.9-5l-6-4.9C29.1 35.5 26.7 36 24 36c-5.3 0-9.7-3.5-11.3-8.3l-6.5 5C9.4 39.5 16.1 44 24 44z"/><path fill="#1976D2" d="M43.6 20.5H42V20H24v8h11.3c-.8 2.3-2.3 4.3-4.4 5.7l6 4.9c-.4.4 6.6-4.8 6.6-14.6 0-1.2-.1-2.4-.4-3.5z"/></svg>
      Continuer avec Google
    </button>
  );
};

export const LoginPage = () => {
  const [email, setEmail] = useState(""); const [password, setPassword] = useState("");
  const { login } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();
  const redirect = new URLSearchParams(loc.search).get("redirect") || "/";
  const [loading, setLoading] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try { await login(email, password); toast.success("Connexion réussie"); nav(redirect); }
    catch (err) { toast.error(formatApiError(err)); }
    finally { setLoading(false); }
  };
  return (
    <div className="je-container py-12 max-w-md" data-testid="login-page">
      <h1 className="text-3xl font-bold mb-2" style={{fontFamily:"Outfit"}}>Connexion</h1>
      <p className="text-gray-500 mb-6">Bon retour parmi nous !</p>
      <form onSubmit={submit} className="space-y-3">
        <input type="email" required placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} className="w-full border rounded-md px-3 py-2.5" data-testid="login-email" />
        <input type="password" required placeholder="Mot de passe" value={password} onChange={(e) => setPassword(e.target.value)} className="w-full border rounded-md px-3 py-2.5" data-testid="login-password" />
        <div className="flex justify-end">
          <Link to="/forgot-password" className="text-xs text-[#0052CC] hover:underline font-semibold" data-testid="forgot-password-link">
            Mot de passe oublié ?
          </Link>
        </div>
        <button type="submit" disabled={loading} className="je-btn-primary w-full disabled:opacity-50 inline-flex items-center justify-center gap-2" data-testid="login-submit">
          {loading && <Spinner className="w-4 h-4" />}
          {loading ? "Connexion..." : "Se connecter"}
        </button>
      </form>
      <div className="my-5 flex items-center gap-3 text-xs text-gray-400 uppercase tracking-widest">
        <div className="flex-1 h-px bg-gray-200" /> ou <div className="flex-1 h-px bg-gray-200" />
      </div>
      <GoogleBtn />
      <p className="text-center text-sm text-gray-500 mt-6">
        Pas encore de compte ? <Link to="/register" className="text-[#0052CC] font-semibold">S'inscrire</Link>
      </p>
    </div>
  );
};

export const RegisterPage = () => {
  const [name, setName] = useState(""); const [email, setEmail] = useState(""); const [password, setPassword] = useState("");
  const { register } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();
  const redirect = new URLSearchParams(loc.search).get("redirect") || "/";
  const [loading, setLoading] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try { await register(name, email, password); toast.success("Compte créé !"); nav(redirect); }
    catch (err) { toast.error(formatApiError(err)); }
    finally { setLoading(false); }
  };
  return (
    <div className="je-container py-12 max-w-md" data-testid="register-page">
      <h1 className="text-3xl font-bold mb-2" style={{fontFamily:"Outfit"}}>Créer un compte</h1>
      <p className="text-gray-500 mb-6">Et débloquez -20% sur vos 2 premières commandes !</p>
      <form onSubmit={submit} className="space-y-3">
        <input required placeholder="Nom complet" value={name} onChange={(e) => setName(e.target.value)} className="w-full border rounded-md px-3 py-2.5" data-testid="register-name" />
        <input type="email" required placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} className="w-full border rounded-md px-3 py-2.5" data-testid="register-email" />
        <input type="password" required minLength={6} placeholder="Mot de passe (6 caractères min)" value={password} onChange={(e) => setPassword(e.target.value)} className="w-full border rounded-md px-3 py-2.5" data-testid="register-password" />
        <button type="submit" disabled={loading} className="je-btn-primary w-full disabled:opacity-50 inline-flex items-center justify-center gap-2" data-testid="register-submit">
          {loading && <Spinner className="w-4 h-4" />}
          {loading ? "Création..." : "Créer mon compte"}
        </button>
      </form>
      <div className="my-5 flex items-center gap-3 text-xs text-gray-400 uppercase tracking-widest">
        <div className="flex-1 h-px bg-gray-200" /> ou <div className="flex-1 h-px bg-gray-200" />
      </div>
      <GoogleBtn />
      <p className="text-center text-sm text-gray-500 mt-6">
        Déjà inscrit ? <Link to="/login" className="text-[#0052CC] font-semibold">Se connecter</Link>
      </p>
    </div>
  );
};
